import { reactive } from 'vue';
import { submitHotelForm } from '../api/submitQnaForm';
import { formConfig } from '../lib/formConfig';
import { FormData } from '../types/FormData';

export function useQnaForm(hotelId: number) {
  const formData = reactive<FormData>({
    email: '',
    phone: '',
    message: '',
    id: hotelId,
  });

  const errors = reactive<Record<keyof Omit<FormData, 'id'>, string | null>>({
    email: null,
    phone: null,
    message: null,
  });

  const validateForm = (): boolean => {
    let isValid = true;

    formConfig.forEach((field) => {
      const value = formData[field.name as keyof Omit<FormData, 'id'>];

      if (field.required && !value) {
        errors[field.name as keyof Omit<FormData, 'id'>] = 'Это поле обязательно';
        isValid = false;
      } else if (field.name === 'email' && value && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value as string)) {
        errors.email = 'Некорректный email';
        isValid = false;
      } else {
        errors[field.name as keyof Omit<FormData, 'id'>] = null;
      }
    });

    return isValid;
  };

  const resetForm = () => {
    Object.assign(formData, { email: '', phone: '', message: '' });
    Object.keys(errors).forEach((key) => {
      errors[key as keyof typeof errors] = null;
    });
  };

  const handleSubmit = async (): Promise<{ success: boolean }> => {
    if (!validateForm()) return { success: false };
    try {
      await submitHotelForm(formData);
      return { success: true };
    } catch (e: unknown) {
      // if (e instanceof Error) {
        // TrackJS.track(e.message);
      // } else {
        // TrackJS.track('An unknown error occurred');
      // }
      return { success: false };
    }
  };

  return {
    formData,
    errors,
    config: formConfig,
    resetForm,
    handleSubmit,
    validateForm,
  };
}
